module.exports = __webpack_public_path__ + "img/DOE-Logo@4x1_1.dfefb0a8.svg";